import { render } from "./routerpendaftaran.vue?vue&type=template&id=09e5fb56"
import script from "./routerpendaftaran.vue?vue&type=script&lang=js"
export * from "./routerpendaftaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__